<template>
  <SpPopover v-model="isDown" class="filter mg-l-20" :height="300" inline="true" :width="620" @open="isDown = true" @close="isDown = false">
    <template #reference>
      <div class="filter-btn">
        <span>{{ $l("Filter") }}</span>
        <i class="icon-arrow-down iconfont" :class="{'arrow-down': isDown}" />
      </div>
    </template>
    <div style="padding: 20px;">
      <SpForm ref="filterForm" v-model="filterForm" class="filter-form" @submit="submit">
        <div class="flex-jc-bt flex-no-wrap mg-t-20">
          <div class="flex-38 flex-al-center flex-jc-end fw-bold">{{ $l('CompanyNameEnglish') }}</div>
          <div class="flex-60">
            <SpSelect v-model="filterForm.name" type="gray3" class="filter-select" height="32" placeholder="">
              <SpSelectOption v-for="item in options" :key="item.value" :label="$l('item.label')" :value="item.value" />
            </SpSelect>
          </div>
        </div>
        <div class="flex-jc-bt mg-t-10">
          <div class="flex-38 flex-al-center flex-jc-end fw-bold">{{ $l('CompanyCategoryFilter') }}</div>
          <div class="flex-60">
            <SpSelect v-model="filterForm.type" type="gray3" height="32" class="filter-select" placeholder="">
              <SpSelectOption v-for="(val, key) in companyCategory" :key="key" :label="$l(val)" :value="key" />
            </SpSelect>
          </div>
        </div>
        <div class="flex-jc-bt mg-t-10">
          <div class="flex-38 flex-al-center flex-jc-end fw-bold">{{ $l('PositionIn') }}</div>
          <div class="flex-60">
            <SpSelect v-model="filterForm.level" type="gray3" height="32" class="filter-select" placeholder="">
              <SpSelectOption v-for="item in positionOptions" :key="item.value" :label="$l(item.label)" :value="item.value" />
            </SpSelect>
          </div>
        </div>
        <div class="flex-jc-ard mg-t-50">
          <SpButton type="cancle" :width="113" :height="42" :label="$L('cancle')" :bold="-1" :circle="true" @click="isDown = false" />
          <SpButton :width="113" :height="42" :label="$L('submit')" :circle="true" />
        </div>
      </SpForm>
    </div>
  </SpPopover>
</template>

<script>
import SpFilter from '@/components/common/SpFilter'
import SpForm from '@/components/common/SpForm.vue'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import SpButton from '@/components/common/SpButton'
import SpPopover from '@/components/common/SpPopover'
import { ENTERPRISE_MASTER, ENTERPRISE_SUB } from '@/config/company'
import { reactive, ref } from 'vue'
export default {
  name: 'FilterForm',
  nameSpace: 'company.CompanyDynamics',
  components: {
    SpFilter,
    SpForm,
    SpSelect,
    SpSelectOption,
    SpButton,
    SpPopover
  },

  props: {
    companyCategory: Object
  },

  emits: ['close'],
  setup (props, ctx) {
    const isDown = ref(false)
    const filterForm = reactive({})
    // const ENTERPRISE_MASTER, ENTERPRISE_SUB
    const positionOptions = [
      {
        label: 'GeneralCompanyOrGroup',
        value: ENTERPRISE_MASTER
      },
      {
        label: 'SubordinateCompanyOrBUOrBranch',
        value: ENTERPRISE_SUB
      },
      {
        label: 'Others',
        value: -1
      }
    ]
    const close = () => {
      ctx.emit('close')
    }
    return {
      isDown,
      filterForm,
      positionOptions,
      close
    }
  }
}
</script>

<style scoped lang="less">
.filter {
  .iconfont {
    margin-left: 12px;
    transform: rotate(0deg);
    transition-duration: .5s;
    display: inline-block;
  }
  .arrow-down {
    transform: rotate(180deg);
    transition-duration: .5s;
  }
}
</style>
